import {
  deleteBanner,
  deleteBackground,
  deleteOverlay,
  batchUpdateScenes,
  removeSourceFromScene
} from '@shoflo/studio-redux/actions';

import { deleteSource } from 'actions/Broadcast';
import { withCurrentParams } from 'actions/utils';
import { filteredScenesForUpdate } from 'utils/broadcastSourceHelper';
import { BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE } from 'actions/Types';
import { setProgram } from 'actions/Broadcast';

/**
 * Removes a source from a scene
 *
 * @param {string} sourceId
 * @param {Array} scenes
 * @param {Object} deleteParams - extra parameters
 */
const deleteSourceFromScene = (sourceId, scenes, deleteParams = {}) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { isBackgroundSource, isOverlaySource, isBannerSource } =
        deleteParams;
      const { brandingSettings } = getState();

      const updatedScenes = removeSourceFromScene(
        scenes,
        sourceId,
        isBackgroundSource,
        brandingSettings?.fonts
      );

      const filteredScenes = filteredScenesForUpdate(updatedScenes);

      const action = {
        type: BROADCAST_UPDATE_SCENE_DELETE_SOURCE_FROM_SCENE,
        request: async apiClient => {
          const response = await batchUpdateScenes(filteredScenes, apiClient, {
            teamId,
            eventId,
            broadcastId
          });

          if (isBackgroundSource) {
            dispatch(deleteBackground(sourceId, { isBackgroundSource: true }));
          } else if (isOverlaySource) {
            dispatch(deleteOverlay(sourceId));
          } else if (isBannerSource) {
            dispatch(deleteBanner(sourceId, {}, setProgram));
          } else {
            dispatch(deleteSource(sourceId));
          }

          return { scenes: response.scenes };
        }
      };

      dispatch(action);
    }
  );
};

export default deleteSourceFromScene;
